/* MXDVS cart drawer ruler, 22.10.2026. The depth ruler of the homepage and collection pages
   (assets/mxdvs-depth-bar.js, option B3) inside the cart drawer: it follows the drawer's own scroll
   (.mx-body), fades in while the drawer scrolls and fades out again when it stops.
   Same look: mm ticks, a label every 100 mm, the counter with rolling digits on the middle line, the notch.
   Sits on the right edge of the drawer's scrolling part (the cart and You might also like, never over the
   footer with the Included chips), on desktop and phones. Nothing runs while it stands still.
   Styles: assets/mxdvs-cart-ruler.css. Loaded on every page by sections/mxdvs-margins.liquid. */
(function () {
  if (window.MxCartRuler) return;
  window.MxCartRuler = true;
  var PX = 96 / 25.4, T = 10 * PX, EVERY = 100, DELAY = 900, W = 17.5;
  var host = null, el, tk, lb, th, D = [], DH = 14, H = 0, V = 0, lastY = -1, lbBase = null, idleT = 0, busy = false, body = null, light = true;

  function grad(col, step, len) {
    return 'repeating-linear-gradient(to bottom,' + col + ' 0 1px,transparent 1px ' + step + 'px) right top/' + (W * len) + 'px 100% no-repeat';
  }

  function build() {
    host = document.querySelector('cart-drawer');
    if (!host || host.querySelector('.mx-cdepth')) return;
    var dg = '', i;
    for (i = 0; i < 4; i++) dg += '<span class="dg"><b>0<br>1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br>0</b></span>';
    el = document.createElement('div');
    el.className = 'mx-cdepth';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="tkw"><i class="tk"></i></div><i class="lb"></i>' +
      '<div class="ixw"><i class="ix"></i><span class="cw">' + dg + '<span class="u">mm</span></span></div><i class="th"></i>';
    host.appendChild(el);
    tk = el.querySelector('.tk'); lb = el.querySelector('.lb'); th = el.querySelector('.th');
    D = [].slice.call(el.querySelectorAll('.dg b'));
  }

  /* place the ruler over the right edge of the scrolling part and draw the ticks for its height */
  function measure() {
    if (!el || !body) return;
    var r = body.getBoundingClientRect();
    if (!r.height) return;
    var drawer = body.closest('.mx-drawer');
    /* stop above the fixed footer (Included chips, totals, checkout): only the cart and You might also like */
    var foot = drawer && drawer.querySelector('.mx-foot'), bottom = r.bottom;
    if (foot) { var fr = foot.getBoundingClientRect(); if (fr.height && fr.top > r.top) bottom = Math.min(bottom, fr.top); }
    var hgt = bottom - r.top;
    light = !drawer || drawer.classList.contains('is-light-page');
    el.classList.toggle('is-dark', !light);
    el.style.top = r.top + 'px';
    el.style.height = hgt + 'px';
    el.style.right = (window.innerWidth - r.right) + 'px';
    V = hgt;
    DH = window.matchMedia('(max-width: 749px)').matches ? 11 : 14;
    var col = light ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.3)';
    var Ah = T * Math.ceil(V / T + 1), K = 2 * Math.ceil(V / (EVERY * PX)) + 1, h = '', i;
    H = (K - 1) / 2;
    for (i = 0; i < K; i++) h += '<span style="top:' + ((i - H) * EVERY * PX).toFixed(2) + 'px"></span>';
    tk.style.cssText = 'top:50%;margin-top:' + (-Ah) + 'px;height:' + (2 * Ah) + 'px;background:' +
      grad(col, PX, .25) + ',' + grad(col, 5 * PX, .45) + ',' + grad(col, 10 * PX, .7);
    lb.innerHTML = h;
    lbBase = null; lastY = -1;
  }

  function frame() {
    busy = false;
    if (!body) return;
    var y = body.scrollTop, max = Math.max(1, body.scrollHeight - body.clientHeight);
    if (y === lastY) return;
    lastY = y;
    var mm = y / PX, q = Math.floor(mm / EVERY), j, k;
    tk.style.transform = 'translate3d(0,' + (-(y % T)) + 'px,0)';
    if (q !== lbBase) {
      lbBase = q;
      var ch = lb.children;
      for (j = 0; j < ch.length; j++) { var v = (q + j - H) * EVERY; ch[j].textContent = v >= 0 && v * PX <= max ? v : ''; }
    }
    lb.style.transform = 'translate3d(0,' + (-(y - q * EVERY * PX)) + 'px,0)';
    for (k = 0; k < 4; k++) {
      var pw = Math.pow(10, k), o = Math.floor(mm / pw) % 10 + (k ? Math.max(0, mm % pw - (pw - 1)) : mm % 1);
      D[3 - k].style.transform = 'translate3d(0,' + (-o * DH) + 'px,0)';
    }
    th.style.transform = 'translate3d(0,' + ((y / max) * (V - 9)) + 'px,0)';
  }

  function show() {
    el.classList.add('is-on');
    clearTimeout(idleT);
    idleT = setTimeout(function () { el.classList.remove('is-on'); }, DELAY);
  }

  /* one capturing listener: the drawer's content is rebuilt after every cart change, so the
     scrolling element is looked up again whenever it scrolls */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.classList.contains('mx-body') || !t.closest('cart-drawer')) return;
    if (!el) build();
    if (!el) return;
    if (t !== body) { body = t; measure(); }
    show();
    if (!busy) { busy = true; requestAnimationFrame(frame); }
  }, { passive: true, capture: true });

  window.addEventListener('resize', function () { if (body) { measure(); frame(); } });
  /* the drawer slides in and its content changes height: measure again when the scroll area changes */
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function () { if (body && body.isConnected) { measure(); frame(); } });
    document.addEventListener('scroll', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('mx-body') && !e.target._mxRo) {
        e.target._mxRo = true; ro.observe(e.target);
      }
    }, { passive: true, capture: true });
  }
})();
